import { proxy, useSnapshot } from 'valtio';

export const messagesSeenState = proxy<Record<string, boolean>>({});

export const setMessageSeen = (feature: string, seen: boolean) => {
  messagesSeenState[feature] = seen;
};

export const useIsMessageSeen = (feature: string) => {
  const messagesSeenStateSnapshot = useSnapshot(messagesSeenState);
  return messagesSeenStateSnapshot[feature];
};
